/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { forwardRef, useEffect, useRef, useState } from "react";
import katex from "katex";

const LatexEditor = forwardRef(function LatexEditor(props, ref) {
  const editorRef = useRef(null);
  const initialCode = props?.code?.trim?.() || "";
  const [latexCode, setLatexCode] = useState(initialCode);

  function handleChange(e) {
    const code = e.target.textContent.trim();
    setLatexCode(code);
  }

  useEffect(() => {
    editorRef.current.focus();
  }, []);

  ref.code = latexCode;
  return (
    <div id="latex--cont" className="latex" style={{ ...props.style }}>
      <code id="latex-editor--cont">
        <pre
          ref={editorRef}
          className="latex-code--cont"
          contentEditable
          spellCheck="false"
          autoFocus
          onInput={handleChange}
          placeholder="Write LaTeX Equation here ..."
        >
          {props.code}
        </pre>
      </code>

      {/* <label htmlFor="latex-preview-id">preview</label> */}
      <div
        ref={ref}
        id="latex-preview-id"
        className="latex-preview--cont"
        dangerouslySetInnerHTML={{
          __html: katex.renderToString(latexCode, {
            displayMode: true,
            output: "mathml",
            throwOnError: false,
          }),
        }}
      ></div>
    </div>
  );
});

export default LatexEditor;
